<div class="template1">

    <footer class="footer-upper ">
        <div class="sub-footer">
            <div class="container">
                <div class="wow fadeInLeft" data-wow-delay="0.1s">
                    <div class="text-center">
                        <p class="copyright_text">Copyright &copy; {{currentYear}} Foreverliving.com, L.L.C All rights reserved.</p>
                    </div>
                </div>                    
            </div>
        </div>
    </footer>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-footer.component.html